<div class="card" style="background: none;">
  <my-tabsautopass class="ap-main-wrapper">
    
    <my-tabautopass [tabTitle]="'FILTER SUMMARY'" >
   
      <div class="ap-container">

        <div class="ap-controls left">
          <button class="ctgfa-btn ctgfa-primary-btn" (click)="filterSummaryList()" ><i class="mdi mdi-filter" aria-hidden="true"></i>Filter Field List</button>
        </div>

        <div class="ap-controls right">
          <button class="ctgfa-btn ctgfa-primary-btn" (click)="onRefreshFilterSummary()"><i class="mdi mdi-refresh " aria-hidden="true"></i>Refresh</button>
          <button class="ctgfa-btn ctgfa-primary-btn" (click)="exportExcelSummaryList()"><i class="mdi mdi-export" aria-hidden="true"></i>Export to Excel</button>
        </div>
          
        <div style="margin-top: 5px;">
            <kendo-grid
            [data]="summaryDetailList"
            [selectable]="true"
            (dblclick)="dbClickSummary($event)"
            [height]="379"
            [columnMenu]="true"
            [sortable]="true"
            (columnVisibilityChange)="onVisibilityChange($event)">

            <kendo-grid-checkbox-column width="55" [headerStyle]="{'padding-left':'12px'}">
                  <ng-template kendoGridHeaderTemplate let-dataItem>
                    <input 
                        type="checkbox" 
                        kendoCheckBox
                        name="selectAll"
                        (change)="onSelectAllChange()" 
                        [checked]="isCheckedAllSummaryDtl"/>
                  </ng-template>
                  <ng-template   kendoGridCellTemplate let-idx="rowIndex"  let-dataItem>
                    <input type="checkbox"  [checked]="dataItem.isSelected"  kendoCheckBox  (change)="selectDisplayCount(idx)" />
                  </ng-template>
            </kendo-grid-checkbox-column>

            <ng-template ngFor [ngForOf]="columnSummary"  let-column>
              <kendo-grid-column
                title = "{{column.title}}"
                field="{{column.property}}"
                [hidden]="column.isHidden == 'true'" >
                    <ng-template kendoGridColumnMenuTemplate let-service="service">
                      <kendo-grid-columnmenu-sort [service]="service">
                      </kendo-grid-columnmenu-sort>
                      <kendo-grid-columnmenu-lock [service]="service">
                      </kendo-grid-columnmenu-lock>
                      <kendo-grid-columnmenu-filter [service]="service">
                      </kendo-grid-columnmenu-filter>
                      <kendo-grid-columnmenu-chooser [service]="service">
                      </kendo-grid-columnmenu-chooser>
                    </ng-template>

                  </kendo-grid-column>                
            </ng-template>

            <!-- <kendo-grid-column field="clientCode" title="Ct Client Name" width="100">
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-sort [service]="service">
                </kendo-grid-columnmenu-sort>
              </ng-template>
            </kendo-grid-column> -->

       

        </kendo-grid>
          </div>
      </div>
    </my-tabautopass>

    <my-tabautopass id="filterList" [tabTitle]="'FILTER LIST'" >

      <div class="ap-container">

        <div class="ap-controls left">
          <button class="ctgfa-btn ctgfa-primary-btn" (click)="exportExcelData()" ><i class="mdi mdi-export" aria-hidden="true"></i>Export to Excel</button>
          <button class="ctgfa-btn ctgfa-primary-btn" (click)="upload()" ><i class="mdi mdi-export" aria-hidden="true"></i>Upload</button>
          <button class="ctgfa-btn ctgfa-primary-btn" id="delete" (click)="deleteFilter()" ><i class="mdi mdi-delete" aria-hidden="true"></i>Delete</button>
        </div>

        <div class="ap-controls right">
          <button class="ctgfa-btn ctgfa-primary-btn" (click)="onRefresh()"><i class="mdi mdi-refresh " aria-hidden="true"></i>Refresh</button>
          <button class="ctgfa-btn ctgfa-primary-btn" (click)="addFilter()"><i class="mdi mdi-plus" aria-hidden="true"></i>Add Filter</button>
        </div>

        <div class="kendoGrid k-grid tr" style="margin-top: 5px;">

          <kendo-grid
            class="ap-grid"
            [data]="gridViewFilterList"
            [pageSize]="state.take"
            [skip]="state.skip"
            [sortable]="true"
            [pageable]="true"
            [resizable]="true"
            [columnMenu]="true"
            [reorderable]="true"
            (pageChange)="pageChange($event)"
            (edit)="editFilter($event)" 
            [height]="336">

            <ng-template kendoGridColumnMenuTemplate let-service="service">
                <kendo-grid-columnmenu-sort [service]="service"></kendo-grid-columnmenu-sort>
                <kendo-grid-columnmenu-lock [service]="service"></kendo-grid-columnmenu-lock>
                <kendo-grid-columnmenu-filter [service]="service"></kendo-grid-columnmenu-filter>
                <kendo-grid-columnmenu-chooser [service]="service"></kendo-grid-columnmenu-chooser>
            </ng-template>

            <kendo-grid-command-column [headerStyle]="headerStyle" title="" width="70" [columnMenu]="false" [reorderable]="false" [locked]="true" >
              <ng-template kendoGridCellTemplate>
                  <button kendoGridEditCommand [primary]="true" style="margin: 5px;">Edit</button>
              </ng-template>
            </kendo-grid-command-column>

            <kendo-grid-column [headerStyle]="headerStyle" title="" width="55" [reorderable]="false" [locked]="true" >
              <ng-template kendoGridColumnMenuTemplate let-service="service">
                    <kendo-grid-columnmenu-chooser [service]="service">
                  </kendo-grid-columnmenu-chooser>
               </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem>
               <input type="checkbox"  name="checked" [(ngModel)]="dataItem.IsChecked"(change)="selectRuleList(dataItem)" [checked]="listRuleSelected"/>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column [headerStyle]="headerStyle" field="Id" title="RULE ID" width="725" [columnMenu]="false" media="(min-width: 700px)"> </kendo-grid-column>

            <kendo-grid-column [headerStyle]="headerStyle" field="FilterName" title="FILTER NAME" width="800"[columnMenu]="false" media="(min-width: 800px)">  </kendo-grid-column>
          
          </kendo-grid>
        </div>   

        </div>       
    </my-tabautopass>

  </my-tabsautopass>
</div>
  
  <kendo-window [left]="350"  *ngIf="dialogOpened" (close)="closeDialog('dialog')" [minWidth]="250" [width]="450">
    <input type="text"   class="k-textbox" style="width:400px;margin: 10px;" placeholder="Template Name"  [(ngModel)]="templateName" class="form-control " >
    <button class="k-button k-primary" style="float: right;margin-right: 10px;" kendoButton   (click)="saveTemplateDialog()">Save</button>
  </kendo-window >
  <div class="mTest">
   <kendo-window [width]="1100" [height]="400" [left]="90"   *ngIf="windowOpenedManualTest" (close)="closeManualTest()">  
      <div class="row">
        <div class="col-md-8">
          <div class="card">
            <div class="card-body" style="box-shadow: 0px 0px 3px 1px #dbe4db;
            height: 300px;
            padding: 5px;
            border-radius: 5px;">
              <div  style="padding: 20px; border-bottom: none;border-top: none;height: 250px;">
                <span *ngIf="ruleTemplateList.length > 0">
                      <span  *ngFor="let ruleTemp of ruleTemplateList;let i = index" [attr.data-index]="i" >
                        <div class="row">
                          <div class="col-md-10">
                            <label for="inputname"class="control-label col-form-label " style="font-size: 11px;">
                              <ng-select  [searchWhileComposing] = "true" (change)="onChange(ruleTemp)" 
                                class="form-control" style="width: 160px;height: 29px;font-size: 11px; margin-left: 5px;
                                border:none;
                                padding: 0px;
                                display: inline-block;"  [(ngModel)]="ruleTemp.Entity">
                                <ng-option *ngFor="let item of  entityDropDown" [value]="item.value">{{item.name}}</ng-option>
                              </ng-select>
                            </label>
          
                            <label for="inputname"class="control-label col-form-label " style="font-size: 11px;">
                              <ng-select  [searchWhileComposing] = "true" 
                                 class="form-control" style="width: 160px;height: 29px;font-size: 11px; margin-left: 5px;
                                 border:none;
                                 padding: 0px;
                                 display: inline-block;"  [(ngModel)]="ruleTemp.Field">
                                <ng-option *ngFor="let item of  fieldDropDown" [value]="item.value">{{item.name}}</ng-option>
                              </ng-select>
                            </label>
          
                            <label for="inputname"  style="padding: 2px;font-size: 11px;width: 200px;" >
                              <input type="text"  [(ngModel)]="ruleTemp.Value" class="form-control " style="width: 160px;height: 31px;font-size: 11px;" >
                            </label>
                          </div>
                          <div class="col-md-2">
                            <div>
                              <button class="k-button k-primary btn-info.btn-outline:hover" kendoButton  style="margin-top:10px; float: right;"  (click)="closeDiv(i)" id="{{i}}">close</button>
                            </div>
                          </div>
                        </div>
                      </span>
                </span>
              </div>
              <div style="padding-right: 10px;height: 40px;border-top: none;border-radius: 0px 0px 5px 0px;">
                  <button   class="k-button k-primary" kendoButton style="float: right;margin-right: 10px;"  (click)="addNewManualTest()"> +Field</button>
                  <button   class="k-button k-primary" kendoButton style="float: right;margin-right: 10px;"  (click)="executeManualTest()"> Execute</button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card">
            <div class="card-body" style="box-shadow: 0px 0px 3px 1px #dbe4db;
            background: #fdfdfdcf;
            height: 300px;
            padding: 5px;
            border-radius: 5px;">
                <div style="margin:5px; border:1px solid rgba(210, 212, 210, 0.467); height: 235px;" >
                <div style="margin: 5px;">
                <input type="text" class="k-textbox"  [(ngModel)]="templateFilter"  style="width:100%;font-size: 11px;padding-left: 10px;border-radius: 5px;"  placeholder="Search Template" (ngModelChange)="searchTemplate()">
                </div>
                <div style="text-align: center;padding: 15px;font-size: 12px;color: #909090;" *ngIf="templateNameList?.length == 0">
                  <span style="margin-top: 5px;font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue, sans-serif;"> No result found. </span> 
              </div>
                <table class="table" style="margin-top: 5px;font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue, sans-serif;">
                <tr *ngFor="let temp of templateNameList">
                <td style="border: none;width: 220px;padding-bottom: 0px;"><span (dblclick)="dbClickTemplate(temp)">{{ temp.Name}}</span></td>
                <td style="border: none;padding-bottom: 0px;"><span (click)="deleteTemplate1(temp)" style="cursor: pointer;"><i class="mdi mdi-delete" aria-hidden="true"></i> Delete</span></td>
                </tr>
                </table>
                </div>
                <div style="padding-top: 5px;">
                <button   class="k-button k-primary" kendoButton style="float: right;"  (click)="saveTemplate()"> Save Template</button>
                </div>
            </div>
          </div>
        </div>
       </div>
  </kendo-window>
</div>

  <kendo-window [width]="600"  *ngIf="windowOpened" (close)="close()" style="min-width: 120px;
  min-height: 100px;
  position: absolute;
  z-index: 10002;
  width: 500px;
  top: 300px;
  left: 400px;">
    <div>
      <input class="k-textbox" style="width:400px;margin: 10px;" placeholder="Invoice Id" [(ngModel)]="invoiceIds" />
      <button kendoButton class="k-button k-primary" (click)="execute()" >Execute</button>
    </div>
    <div *ngIf="jsonResult != undefined" style="overflow-x: auto; overflow-y: auto; white-space: nowrap; " >
      <ngx-json-viewer [json]="jsonResult"></ngx-json-viewer>
    </div>
  </kendo-window>
  
  <kendo-window  [title]="'Fields List'" [top]="20" [left]="500" [width]="500" [height]="500"  *ngIf="windowOpenedSummary" (close)="closeSummaryCount()" >  
      <kendo-panelbar>
        <kendo-panelbar-item [title]="'Clients'">
            <ng-template kendoPanelBarContent>
              <div style = "padding-left: 5px;" *ngFor = "let f of clientList" >
                <label class="k-label" *ngIf="f.title !='Count' && f.title != filterIds ">  <!-- dong display the count and filter id in modal -->
                  <input type="checkbox" [checked]="f.isHidden == 'false'" kendoCheckBox    (click)="summaryOnChange(f)"/>  
                  {{f.title}}
                </label>
              </div>
            </ng-template>
        </kendo-panelbar-item>
    </kendo-panelbar>
  
    <kendo-panelbar>
      <kendo-panelbar-item [title]="'Carrier'">
        <ng-template kendoPanelBarContent>
          <div style = "padding-left: 5px;"*ngFor = "let f of carrierList" >
            <label class="k-label" *ngIf="f.title !='Count' && f.title != filterIds ">  <!-- dong display the count and filter id in modal -->
              <input type="checkbox" [checked]="f.isHidden == 'false'" kendoCheckBox   (click)="summaryOnChange(f)"/>  
              {{f.title}}
            </label>
          </div>
        </ng-template>
      </kendo-panelbar-item>
    </kendo-panelbar>

    <kendo-panelbar>
      <kendo-panelbar-item [title]="'Client Carrier'">
        <ng-template kendoPanelBarContent>
          <div style = "padding-left: 5px;"*ngFor = "let f of clientCarrierList" >
            <label class="k-label" *ngIf="f.title !='Count' && f.title != filterIds ">  <!-- dong display the count and filter id in modal -->
              <input type="checkbox" [checked]="f.isHidden == 'false'" kendoCheckBox   (click)="summaryOnChange(f)"/>  
              {{f.title}}
            </label>
          </div>
        </ng-template>
      </kendo-panelbar-item>
    </kendo-panelbar>

    <kendo-panelbar>
      <kendo-panelbar-item [title]="'Invoice'">
        <ng-template kendoPanelBarContent>
          <div style = "padding-left: 5px;"*ngFor = "let f of invoiceList" >
            <label class="k-label" *ngIf="f.title !='Count' && f.title != filterIds ">  <!-- dong display the count and filter id in modal -->
              <input type="checkbox" [checked]="f.isHidden == 'false'" kendoCheckBox   (click)="summaryOnChange(f)"/>  
              {{f.title}}
            </label>
          </div>
        </ng-template>
      </kendo-panelbar-item>
    </kendo-panelbar>

    <kendo-panelbar>
      <kendo-panelbar-item [title]="'Shipment'">
        <ng-template kendoPanelBarContent>
          <div style = "padding-left: 5px;"*ngFor = "let f of shipmentList" >
            <label class="k-label" *ngIf="f.title !='Count' && f.title != filterIds ">  <!-- dong display the count and filter id in modal -->
              <input type="checkbox" [checked]="f.isHidden == 'false'" kendoCheckBox   (click)="summaryOnChange(f)"/>  
              {{f.title}}
            </label>
          </div>
        </ng-template>
      </kendo-panelbar-item>
    </kendo-panelbar>

    <kendo-panelbar>
      <kendo-panelbar-item [title]="'Uoms'">
        <ng-template kendoPanelBarContent>
          <div style = "padding-left: 5px;"*ngFor = "let f of uomsList" >
            <label class="k-label" *ngIf="f.title !='Count' && f.title != filterIds ">  <!-- dong display the count and filter id in modal -->
              <input type="checkbox" [checked]="f.isHidden == 'false'" kendoCheckBox  (click)="summaryOnChange(f)"/>  
              {{f.title}}
            </label>
          </div>
        </ng-template>
      </kendo-panelbar-item>
    </kendo-panelbar>

    <kendo-panelbar>
      <kendo-panelbar-item [title]="'Invoice Charges'">
        <ng-template kendoPanelBarContent>
          <div style = "padding-left: 5px;"*ngFor = "let f of invchargesList" >
            <label class="k-label" *ngIf="f.title !='Count' && f.title != filterIds ">  <!-- dong display the count and filter id in modal -->
              <input type="checkbox" [checked]="f.isHidden == 'false'" kendoCheckBox   (click)="summaryOnChange(f)"/>  
              {{f.title}}
            </label>
          </div>
        </ng-template>
      </kendo-panelbar-item>
    </kendo-panelbar>
    
    <kendo-panelbar>
      <kendo-panelbar-item [title]="'Invoice Id'">
        <ng-template kendoPanelBarContent>
          <div style = "padding-left: 5px;"*ngFor = "let f of invoiceIdList" >
            <label class="k-label" *ngIf="f.title !='Count' && f.title != filterIds ">  <!-- dong display the count and filter id in modal -->
              <input type="checkbox" [checked]="f.isHidden == 'false'" kendoCheckBox   (click)="summaryOnChange(f)"/>  
              {{f.title}}
            </label>
          </div>
        </ng-template>
      </kendo-panelbar-item>
    </kendo-panelbar>

    <kendo-panelbar>
      <kendo-panelbar-item [title]="'Client Fields'">
        <ng-template kendoPanelBarContent>
          <div style = "padding-left: 5px;"*ngFor = "let f of clientFieldsList" >
            <label class="k-label" *ngIf="f.title !='Count' && f.title != filterIds ">  <!-- dong display the count and filter id in modal -->
              <input type="checkbox" [checked]="f.isHidden == 'false'" kendoCheckBox   (click)="summaryOnChange(f)"/>  
              {{f.title}}
            </label>
          </div>
        </ng-template>
      </kendo-panelbar-item>
    </kendo-panelbar>

    <kendo-panelbar>
      <kendo-panelbar-item [title]="'Shipment Ids'">
        <ng-template kendoPanelBarContent>
          <div style = "padding-left: 5px;"*ngFor = "let f of invsidList" >
            <label class="k-label" *ngIf="f.title !='Count' && f.title != filterIds ">  <!-- dont display the count and filter id in modal -->
              <input type="checkbox" [checked]="f.isHidden == 'false'" kendoCheckBox   (click)="summaryOnChange(f)"/>  
              {{f.title}}
            </label>
          </div>
        </ng-template>
      </kendo-panelbar-item>
    </kendo-panelbar>
    <br>
    <button style="float:right" class="k-button k-primary" kendoButton (click)="DisplaySummaryCount()">OK</button>
  </kendo-window>


<kendo-excelexport [data]="allFilter" fileName="Rules.xlsx" #excelexport>
  <kendo-excelexport-column field="Id" [locked]="true" title="Filter Id" [width]="200">
  </kendo-excelexport-column>
  <kendo-excelexport-column field="FilterName" title="Filter Name" [width]="350">
  </kendo-excelexport-column>
</kendo-excelexport>


<div >
  <ng-template let-filter="filter" #autopassEdit>
    <autopassform [filter]="filter"></autopassform>
  </ng-template>
</div>


